<template>
  <div class="info">
    <div class="left">
      <div class="top">
        <span v-if="this.$store.state.subscription.active == 0" class="subscription-canceled">Your subscription is canceled.</span>
        <br>
        <span class="info-order-id"
          >Order ID:
          <span class="bold">{{
            this.$store.state.subscription.order_id
          }}</span></span
        >
        <customer-info-view />
      </div>
      <div class="bottom">
        <payment-details-view v-if="this.$store.state.subscriptionTypeLoaded" />
      </div>
    </div>
    <div class="right">
      <div class="top">
        <logo-view />
      </div>
      <div class="middle">
        <subscription-type-view
          v-if="this.$store.state.subscriptionTypeLoaded"
        />
      </div>
      <div class="bottom">
        <cancel-view />
      </div>
    </div>
  </div>
</template>

<script>
import SubscriptionTypeView from "@/components/Checkout/SubscriptionType.vue";
import CustomerInfo from "@/components/Order/CustomerInfo.vue";
import PaymentDetailsView from "@/components/Subscription/PaymentDetails.vue";
import LogoView from "@/components/Checkout/Logo.vue";
import CancelView from "@/components/Subscription/Cancel.vue";

export default {
  name: "info-view",
  props: {
    title: String,
  },
  components: {
    "subscription-type-view": SubscriptionTypeView,
    "customer-info-view": CustomerInfo,
    "payment-details-view": PaymentDetailsView,
    "logo-view": LogoView,
    "cancel-view": CancelView,
  },
  computed: {},
  methods: {},
  async mounted() {
    await this.$store.dispatch("getSubscription");
    await this.$store.dispatch("getCountries");
    await this.$store.dispatch(
      "getSubscriptionType",
      this.$store.state.subscription.subscription_type_id
    );
    if (this.$store.state.subscription.vat_id != "") {
      this.$store.commit("assignVatCheckSuccessfull", true);
    }
    this.$store.commit("assignSubscriptionTypeLoaded", true);
  },
};
</script>

<style scoped>
.info {
  width: 100%;
  height: 88.5%;
  display: flex;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 60px;
  padding-right: 60px;
}
.info .right {
  border-left: 1px solid #c7c9c8;
  width: 50%;
  height: 100%;
  padding-left: 60px;
}

.info .left {
  width: 50%;
  padding-right: 60px;
  border-right: 1px solid #c7c9c8;
}
.info .right .top {
  width: 100%;
  height: 20%;
}
.info .left .top {
  width: 100%;
  height: 45%;
  padding-top: 20px;
}
.bold {
  font-weight: bold;
}
.info-order-id {
  font-size: 20px;
}

.right .middle {
  height: 45%;
}

.right .bottom {
  height: 35%;
}
.left .bottom {
  margin-top: 50px;
  height: 45%;
}
.subscription-canceled {
  font-size: 40px;
  color: red;
  margin-bottom: 20px;
  display: flex;
}
</style>
